export function resetAssessmentStorage({ keepSystem = true } = {}) {
  const KEYS = [
    '@survey-questions',
    '@screening-questions',
    '@screened-systems',
    '@loaded-systems',
    '@is-simulated'
  ];
  KEYS.forEach(k => localStorage.removeItem(k));
  if (!keepSystem) localStorage.removeItem('@app-system');
}